import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";

const symptoms = [
  "Abnormal vaginal bleeding",
  "Vaginal bleeding after menopause",
  "Ovarian Cysts",
  "Changes in menstrual cycle",
  "Persistent pelvic pain",
  "Uterine tumours",
  "Persistent discharge per vagina",
  "Bloating or abdominal swelling",
  "Unexplained weight loss",
  "Bleeding after intercourse",
  "Severe pain during menses",
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.05 } },
};

const pillVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.35 } },
};

export default function SymptomsSection() {
  return (
    <section
      id="symptoms"
      data-testid="symptoms-section"
      className="py-24 md:py-32 bg-[#1E3F33]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <div className="flex items-center gap-3 mb-4">
            <AlertTriangle className="w-5 h-5 text-[#C29F60]" />
            <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#C29F60]">
              Know the Warning Signs
            </p>
          </div>
          <h2
            data-testid="symptoms-heading"
            className="font-serif text-4xl sm:text-5xl tracking-tight text-[#F9F9F6] leading-tight max-w-3xl"
          >
            Early Signs of Gynecologic Cancer You Should Not Ignore
          </h2>
          <p className="text-base sm:text-lg text-[#8FA998] mt-4 max-w-2xl leading-relaxed">
            Early detection plays a crucial role in successful cancer treatment. Consult a gynecologic oncologist if you experience any of these symptoms.
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          className="flex flex-wrap gap-3"
          data-testid="symptoms-list"
        >
          {symptoms.map((symptom, i) => (
            <motion.span
              key={symptom}
              variants={pillVariants}
              data-testid={`symptom-pill-${i}`}
              className="inline-block bg-[#2C5545] text-[#F9F9F6] px-5 py-2.5 rounded-full text-sm sm:text-base font-medium border border-[#8FA998]/20 hover:bg-[#8FA998]/20 transition-colors duration-200"
            >
              {symptom}
            </motion.span>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-10"
        >
          <a
            href="/book-appointment"
            data-testid="symptoms-cta-btn"
            className="inline-flex items-center gap-2 bg-[#C29F60] text-[#1E3F33] px-7 py-3.5 rounded-full text-sm font-bold hover:bg-[#d4b170] transition-colors duration-200"
          >
            Get Evaluated Early for Better Outcomes
          </a>
        </motion.div>
      </div>
    </section>
  );
}
